import { paragraphStyles } from 'components/Documents/documentStyles';
import { saveAs } from 'file-saver';
import docx from 'remark-docx';
import remarkGfm from 'remark-gfm';
import markdown from 'remark-parse';
import { unified } from 'unified';

interface MarkdownNode {
  type: string;
  children?: MarkdownNode[];
}

// remark-docx has no HTML support: it prints an `html` node as literal text, in a paragraph of its own
// that ends up nested inside the enclosing paragraph (schema-invalid WordprocessingML, Word offers to
// repair the file). The AI audit reports open with an inline <span> disclaimer, and model output may
// carry other inline tags. Dropping the html nodes keeps the text between the tags and loses only the
// markup, which the docx path cannot render anyway.
const stripHtmlNodes = (node: MarkdownNode): void => {
  if (!node.children) return;

  node.children = node.children.filter((child) => child.type !== 'html');
  node.children.forEach(stripHtmlNodes);
};

const remarkStripHtml = () => (tree: MarkdownNode) => {
  stripHtmlNodes(tree);
};

export const createMarkdownDocxBlob = async (content: string): Promise<Blob> => {
  const processor = unified()
    .use(markdown)
    .use(remarkGfm)
    .use(remarkStripHtml)
    .use(docx, { output: 'blob', styles: { paragraphStyles: paragraphStyles } });
  const document = await processor.process(content);

  return document.result as Blob;
};

export const downloadMarkdownDocx = async (content: string, fileName: string) => {
  if (!content) return;

  const blob = await createMarkdownDocxBlob(content);
  saveAs(blob, fileName);
};
